/**
 * Model representing a consent item with hierarchical structure
 * Used for dynamic consent form rendering from configuration
 */
export class ConsentItem {
  isChecked: boolean = false;
  consent: string = '';
  hasChildren: boolean = false;
  isRequired: boolean = false;
  children?: ConsentItem[] = [];

  constructor(
    isChecked: boolean = false,
    consent: string = '',
    hasChildren: boolean = false,
    isRequired: boolean = false,
    children?: ConsentItem[]
  ) {
    this.isChecked = isChecked;
    this.consent = consent;
    this.hasChildren = hasChildren;
    this.isRequired = isRequired;
    this.children = children || [];
  }
}
